/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { SubmissionSummary } from './SubmissionSummary';
import {
    SubmissionSummaryFromJSON,
    SubmissionSummaryFromJSONTyped,
    SubmissionSummaryToJSON,
    SubmissionSummaryToJSONTyped,
} from './SubmissionSummary';

/**
 * 
 * @export
 * @interface UploadBatchItem
 */
export interface UploadBatchItem {
    /**
     * 
     */
    index: number;
    /**
     * 
     */
    status: string;
    /**
     * 
     */
    detail: SubmissionSummary | null;
    /**
     * 
     */
    capturedAt?: Date | null;
}

/**
 * Check if a given object implements the UploadBatchItem interface.
 */
export function instanceOfUploadBatchItem(value: object): value is UploadBatchItem {
    if (!('index' in value) || value['index'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('detail' in value) || value['detail'] === undefined) return false;
    return true;
}

export function UploadBatchItemFromJSON(json: any): UploadBatchItem {
    return UploadBatchItemFromJSONTyped(json, false);
}

export function UploadBatchItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchItem {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'],
        'status': json['status'],
        'detail': SubmissionSummaryFromJSON(json['detail']),
        'capturedAt': json['captured_at'] === undefined ? undefined : json['captured_at'] === null ? null : (parseDateTime(json['captured_at'])),
    };
}

export function UploadBatchItemToJSON(json: any): UploadBatchItem {
    return UploadBatchItemToJSONTyped(json, false);
}

export function UploadBatchItemToJSONTyped(value?: UploadBatchItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'status': value['status'],
        'detail': SubmissionSummaryToJSON(value['detail']),
        'captured_at': value['capturedAt'] == null ? value['capturedAt'] : serializeDateTime(value['capturedAt']),
    };
}

